<template>
  <expert-layout>
    <v-layout row wrap class="ml-3 pa-1">
      <!-- Expertise -->

      <v-flex xs12 class="list-section" v-if="packageItem.expertise && packageItem.expertise>user.expertise.length">
        <v-toolbar dense flat color="sectionColor">Expertise</v-toolbar>
        <expertise :expertiseNo="packageItem.expertise"></expertise>
      </v-flex>

      <v-flex xs12 v-else>
        <v-toolbar dense flat color="sectionColor">Expertise</v-toolbar>
        <v-card>
          <v-alert :value="true" type="warning">Your expertise  limit is {{packageItem.expertise}}</v-alert>
          <v-card-text>
            <v-flex xs12 class="text-xs-left">
              <div style="font-size: 18px;">
                <ul>
                  <li v-for="(expertise, index) in user.expertise" v-bind:key="index">
                    {{expertise.category}} - {{expertise.subcategory}}
                    <v-btn icon @click="deleteModal(expertise)">
                      <v-icon color="red darken-1">delete</v-icon>
                    </v-btn>
                  </li>
                </ul>
              </div>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- End of epertise -->

      <!-- Location -->
      <v-flex xs12 class="list-section mt-3">
        <v-toolbar dense flat color="sectionColor">Location <span class="red--text ml-5">Your Plan Allows {{packageItem.locations}} Operating Locations</span></v-toolbar>
        <locations :locations="packageItem.locations"></locations>
      </v-flex>
      <!-- End  -->

      <!-- About -->
      <v-flex xs12 class="list-section mt-3">
        <v-toolbar dense flat color="sectionColor">About me</v-toolbar>
        <about></about>
      </v-flex>
      <!-- End -->

      <!-- Experience -->
      <v-flex xs12 class="list-section mt-3">
        <v-toolbar dense flat color="sectionColor">Work Experience</v-toolbar>
        <experience></experience>
      </v-flex>
      <!-- End -->

      <!-- Certificates -->
      <v-flex xs12 class="list-section mt-3">
        <v-toolbar dense flat color="sectionColor">Certificates (Images or Pdf Only - 5 Max) - one at a time</v-toolbar>
        <certificates></certificates>
      </v-flex>
      <!-- End of -->

      <!-- projects -->
      <v-flex xs12 class="list-section text-xs-center mt-3">
        <v-alert
          :value="true"
          type="info"
        >Your projects limit is {{packageItem.projects}}. They give you a better chance to get jobs.</v-alert>
        <v-btn flat color="btnColor" :to="'projects'">
          <v-icon>add</v-icon>Add Project
        </v-btn>
      </v-flex>
      <!-- end  -->

      <!-- snack -->
      <v-snackbar
        :timeout="timeout"
        top
        right
        v-model="expertiseSnackbar"
        color="red"
      >{{ expertiseError }}</v-snackbar>
      <!-- end -->

      <!-- Delete dialog -->
      <v-dialog v-model="deleteDialog" max-width="650px">
        <v-toolbar dense flat color="primary" dark>
          Confirmation
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-layout wrap>
            <v-flex xs12 class="del pa-3">
              Are you sure you want to delete -
              <span style="color: red">{{deleteItem.category}}</span> - the expertise?
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn color="green darken-1" :loading="loader" small dark @click="deleteExpertise()">
                <v-icon>check</v-icon>yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- End of delete dialog -->
    </v-layout>

  </expert-layout>
</template>

<script>
import BioData from "./_components/bio_data.vue";
import Expertise from "./_components/expertise.vue";
import About from "./_components/about.vue";
import Experience from "./_components/experience.vue";
import Certificates from "./_components/certificates.vue";
import Locations from "./_components/locations.vue";
import { mapGetters } from "vuex";
export default {
  name: "ExpertProfileIndex",
  components: {
    BioData,
    Expertise,
    About,
    Experience,
    Certificates,
    Locations
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["projectsNo"]),
    ...mapGetters(["expertiseNo"]),
    ...mapGetters(["locationNo"])
  },
  data() {
    return {
      loader: false,
      deleteDialog: false,
      expertise: null,
      deleteItem: {},
      expertiseSnackbar: false,
      expertiseError: "Please select expertise",
      timeout: 4000,
      subscription: {},
      packageItem: {},
    };
  },
  methods: {
    deleteModal(expertise) {
      this.deleteItem = expertise;
      this.deleteDialog = true;
    },
    deleteExpertise() {
      const dataArray = this.user.expertise;
      const category = dataArray.find(category => {
        return category._id === this.deleteItem._id;
      });

      const pos = dataArray.indexOf(category);
      if (pos === -1) {
        return;
      }
      dataArray.splice(pos, 1);
      const data = { expertise: dataArray };
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.deleteItem = {};
          self.deleteDialog = false;
        });
    },
    getUserProfile() {
      const user = this.user;
      if (user._id != undefined) {
        const self = this;
        const res = this.$store
          .dispatch("get", "/user/" + user._id)
          .then(res => {
              if(res.subscription) {
                this.subscription = res.subscription;
                const resPackage = this.$store
                .dispatch("get", "/packages/" + this.subscription.packageId)
                .then(res => {
                  this.packageItem = res.packageItem;
                });  
              }
          });
      }
    }
  },
  created() {
    this.getUserProfile();
    const sub = localStorage.getItem("expertise");
    this.expertise = sub;
    if(this.$route.query.error != null) {
      this.expertiseSnackbar = true;
      this.expertiseError = "You must have a Sonko account to engage an expert";
      this.$router.push("/expert/profile");
    }
  }
};
</script>


<style scoped>
</style>
